import {StyleSheet} from 'aphrodite';

const gridTitleStyles = StyleSheet.create({
  gridTitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '72px',
    justifyContent: 'space-between',
    boxShadow: '0px 2px 4px 0px rgba(151, 151, 153, 0.25)',
    cursor: 'default',
  },
  gridTitleInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    padding: '18px',
  },
  gridTitleIcon: {
    width: '32px',
    height: '32px',
    fill: '#979799',
  },
  gridTitleInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  gridTitleTemplateCollectionName: {
    fontSize: '13px',
    color: '#656566',
    cursor: 'pointer',
  },
  gridTitleTemplateCollectionNameNoLink: {
    fontSize: '13px',
    color: '#656566',
  },
  withTrailingSlash: {
    ':after': {
      content: '" /"',
    },
  },
  gridTitleTemplateName: {
    fontSize: '18px',
    color: '#1B1B1F',
    fontWeight: 600,
    cursor: 'text',
  },
  gridTitleOptions: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '18px',
  },
  resourcePresenceContainer: {
    display: 'flex',
    marginRight: '8px',
    alignItems: 'center',
  },
  secondaryButton: {
    marginRight: '4px',
  },
});

export default gridTitleStyles;
